import { LoggedInAction, LoggedOutAction } from '../types/Actions';

export const loggedIn = (user: firebase.User): LoggedInAction => ({
  type: "LOGGED_IN",
  user,
});

export const loggedOut = (): LoggedOutAction => ({
  type: "LOGGED_OUT",
})